/**
 * Created by chengpanwang on 2017/3/23.
 */
var Logger = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  logLevel: this.DEBUG,
  install (Vue) {
    Vue.prototype.$logger = Logger
    // 日志级别
    if (Vue.prototype.$appConfig.logLevel) {
      this.logLevel = Vue.prototype.$appConfig.logLevel
    }
  },
  debug (msg, ...args) {
    if (this.logLevel > 0) {
      return
    }
    console.debug('DEBUG: ', msg, args)
  },
  info (msg, ...args) {
    if (this.logLevel > 1) {
      return
    }
    console.info('INFO: ', msg, args)
  },
  warn (msg, ...args) {
    if (this.logLevel > 2) {
      return
    }
    console.info('WARN: ', msg, args)
  },
  error (msg, ...args) {
    if (this.logLevel > 3) {
      return
    }
    console.info('ERROR: ', msg, args)
  },
}

export default Logger



// WEBPACK FOOTER //
// ./src/plugins/Logger.js